export const environment = {
  production: true,
  baseApi:'https://server-shopping-romd.onrender.com/api/stock' //"http://localhost:5000/api/stock"


};
